<template>
  <a
      :disabled="disabled"
      :href="href"
      :class="[inputClasses, 'inline-flex items-center hover:underline']">
    <slot/>
  </a>
</template>

<script setup lang="ts">
interface LinkProps {
  href?: string
  color?: string,
  disabled?: boolean
}

const props = withDefaults(defineProps<LinkProps>(), {
  href: '',
  color: 'text-primary-600 dark:text-primary-500',
  disabled: false
})

const inputClasses = computed(() => {
  if (props.disabled) {
    return 'cursor-not-allowed text-text-secondary pointer-events-none'
  }

  return props.color
});
</script>